import axios from "axios";
import Vue from "vue";

const Axios = (function() {
  function _provision(emitter, localStorageService) {
    let isRefreshing = false;
    let failedQueue = [];

    const processQueue = (error, token = null) => {
      failedQueue.forEach((prom) => {
        if (error) {
          prom.reject(error);
        } else {
          prom.resolve(token);
        }
      });

      failedQueue = [];
    };

    var axiosClient = axios.create({
      baseURL: process.env.VUE_APP_API,
      json: true,
      withCredentials: true,
    });

    Vue.prototype.$client = axiosClient;

    axiosClient.interceptors.request.use(
      (config) => {
        if (!((config.data && config.data.noProgress) || config.noProgress))
          Vue.prototype.$emitter.emit("loading-start");

        const token = localStorage.getItem("access_token");

        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );

    axiosClient.interceptors.response.use(
      (response) => {
        Vue.prototype.$emitter.emit("loading-end");

        if (response.status === 200 && response.data.isSuccess == false) {
          Vue.prototype.$emitter.emit("error", response.data.errors[0]);
        }
        return response;
      },
      function(error) {
        Vue.prototype.$emitter.emit("loading-end");

        const originalRequest = error.config;

        if (error.response.status != 200 && error.response.status != 401) {
          Vue.prototype.$emitter.emit(
            "error",
            "There was an unexpected server error."
          );
        }

        if (error.response.status === 401 && !originalRequest._retry) {
          if (isRefreshing) {
            return new Promise(function(resolve, reject) {
              failedQueue.push({ resolve, reject });
            })
              .then((token) => {
                originalRequest.headers["Authorization"] = "Bearer " + token;
                return axiosClient(originalRequest);
              })
              .catch((err) => {
                return Promise.reject(err);
              });
          }

          originalRequest._retry = true;
          isRefreshing = true;

          return new Promise(function(resolve, reject) {
            const refreshToken = localStorage.getItem("refresh_token");

            axiosClient
              .post(process.env.VUE_APP_API + "api/auth/refresh", {
                refreshToken,
              })
              .then((response) => {
                console.log(response.data);
                if (response.data.isSuccess) {
                  localStorage.setItem(
                    "access_token",
                    response.data.value.token
                  );
                  localStorage.setItem(
                    "refresh_token",
                    response.data.value.refreshToken
                  );

                  //
                  axios.defaults.headers.common["Authorization"] =
                    "Bearer " + response.data.value.token;
                  originalRequest.headers["Authorization"] =
                    "Bearer " + response.data.value.token;
                  processQueue(null, response.data.value.token);
                  resolve(axiosClient(originalRequest));
                } else {
                  localStorage.removeItem("access_token");
                  localStorage.removeItem("refresh_token");
                  location.href = "/#/";
                }
              })
              .catch((err) => {
                processQueue(err, null);
                reject(err);
              })
              .finally(() => {
                isRefreshing = false;
              });
          });
        }

        return Promise.reject(error);
      }
    );
  }
  return {
    provision: _provision,
  };
})();
export default Axios;
